<template>
  <div class="row">
    <div class="col-md-3" v-for="card in cards" :key="card.label">
      <div class="panel panel-default">
        <div class="panel-body text-center">
          <h4 class="text-muted">
            {{ card.label }}
            <CalculationTooltip :text="card.tooltip" />
          </h4>
          <p class="h2">{{ card.value }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalculationTooltip from './CalculationTooltip.vue';

export default {
  name: 'SummaryCards',
  components: { CalculationTooltip },
  props: {
    summary: { type: Object, required: true }
  },
  computed: {
    cards() {
      if (!this.summary) return [];
      return [
        {
          label: 'Sessions Completed',
          value: this.summary.total_sessions_completed,
          tooltip: 'Count of all drives with status "Complete" in the selected date range.'
        },
        {
          label: 'Hours Delivered',
          value: this.summary.total_hours_delivered,
          tooltip: 'Sum of session lengths (in minutes, converted to hours) for all completed drives in the selected date range.'
        },
        {
          label: 'Utilization Rate',
          value: this.summary.utilization_rate + '%',
          tooltip: 'Completed sessions divided by (completed + available slots), as a percentage. Measures how much of your available capacity was used.'
        },
        {
          label: 'Cancellation Rate',
          value: this.summary.cancellation_rate + '%',
          tooltip: 'Cancelled sessions divided by (cancelled + completed + scheduled sessions), as a percentage.'
        },
      ];
    }
  }
};
</script>
